import axios from '@/services/api'

/**
 * @param {Object} query
 *
 * @returns {Promise<Object>}
 */
export const fetchEvents = (query = '') => {
	const url = `/api/events${query}`
	return axios.get(url)
}

/**
 * @param {Number} id
 * @param {String} queryString
 *
 * @returns {Promise<Object>}
 */
export const getActionFiles = (id, queryString) => {
	const url = `/api/event-action-files?action_id=${id}&${queryString}`
	return axios.get(url)
}

/**
 * @param {Number} id
 * @param {String} queryString
 *
 * @returns {Promise<Object>}
 */
export const getActionLinks = (id, queryString) => {
	const url = `/api/event-action-links?action_id=${id}${queryString}`
	return axios.get(url)
}

/**
 *
 * @returns {Promise<Object>}
 */
export const fetchEventCategories = (query) => {
	const url = `/api/event-categories`
	return axios.get(url, { params: query })
}

/**
 * @param {Object} query
 *
 * @returns {Promise<Object>}
 */
export const fetchPartners = (query = '') => {
	const url = `/api/partners${query}&expand=partner_description,partner_location,follow_status,mapUrl,group_id`
	return axios.get(url)
}

/**
 * @param {number} eventId
 * @param {object} query
 *
 * @returns {Promise<Object>}
 */
export const getEvent = (eventId, query = {}) => {
	const url = `/api/events/${eventId}`
	return axios.get(url, { params: query })
}

/**
 * @param {object} query
 *
 * @returns {Promise<Object>}
 */
export const getAgendaEvent = (query = {}) => {
	const url = `/api/event-agenda${query}`
	return axios.get(url)
}

/**
 * @param {object} data
 *
 * @returns {Promise<Object>}
 */
export const followEvent = (data = {}) => {
	const url = `/api/event-users`
	return axios.post(url, data)
}

/**
 * @param {number} eventId
 *
 * @returns {Promise<Object>}
 */
export const unfollowEvent = (eventId) => {
	const url = `/api/event-users/${eventId}`
	return axios.delete(url)
}

/**
 * @param {Object} query
 *
 * @returns {Promise<Object>}
 */
export const getAttendeesEvent = (query) => {
	const url = `/api/users${query}`
	return axios.get(url)
}

/**
 *
 * @returns {Promise<Object>}
 */
export const getEventSession = (id) => {
	const url = `/api/event-agenda/${id}?expand=session_description,session_location,uploads,speakers,session_question_answers,polls,ratings,event_brief_description`
	return axios.get(url)
}

/**
 *
 * @returns {Promise<Object>}
 */
export const getAttendeeEvent = (id) => {
	const url = `/api/users/${id}?expand=qr,public,follow_note,follow_status,private`
	return axios.get(url)
}

/**
 * @param {object} data
 *
 * @returns {Promise<Object>}
 */
export const addToSchedule = (data = {}) => {
	const url = `/api/event-users-schedule`
	return axios.post(url, data)
}

/**
 * @param {number} eventId
 *
 * @returns {Promise<Object>}
 */
export const removeFromSchedule = (eventId) => {
	const url = `/api/event-users-schedule/${eventId}`
	return axios.delete(url, { Headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const addSessionAgendaQuestion = (data = {}) => {
	const url = '/api/session-question-answers'
	return axios.post(url, data)
}

/**
 * @param {Object} sessionId
 *
 * @returns {Promise<Object>}
 */
export const getSessionQuestions = ({ sessionId, page }) => {
	const url = `/api/session-question-answers?session_id=${sessionId}&page=${page}`
	return axios.get(url)
}

/**
 * @param {number} answerId
 *
 * @returns {Promise<Object>}
 */
export const upvoteSessionQuestion = (answerId) => {
	const url = '/api/session-question-answers-upvote'
	return axios.post(url, { session_question_answer_id: answerId })
}

/**
 * @param {number} answerId
 *
 * @returns {Promise<Object>}
 */
export const deleteUpvoteSessionQuestion = (answerId) => {
	const url = `/api/session-question-answers-upvote/${answerId}`
	return axios.delete(url)
}

/**
 * @param {Object} payload
 *
 * @returns {Promise<Object>}
 */

export const getEventTracks = ({ eventId, page }) => {
	const url = `/api/event-tracks?event_id=${eventId}&page=${page}`
	return axios.get(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const addMyAgenda = (data) => {
	const url = `/api/agenda-users-schedule`
	return axios.post(url, data)
}

/**
 * @param {Number} id
 *
 * @returns {Promise<Object>}
 */
export const removeMyAgenda = (id) => {
	const url = `/api/agenda-users-schedule/${id}`
	return axios.delete(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const voteEventPoll = (data) => {
	const url = `api/polls-history`
	return axios.post(url, data)
}

/**
 * @param {String} query
 *
 * @returns {Promise<Object>}
 */

export const getEventSpeakersById = (query) => {
	const url = `/api/speakers${query}`
	return axios.get(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const voteEventRating = (data) => {
	const url = 'api/event-rating'
	return axios.post(url, data)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const voteSessionRating = (data) => {
	const url = 'api/session-rating'
	return axios.post(url, data)
}

/**
 * @param {Number} id
 *
 * @returns {Promise<Object>}
 */
export const getExhibitorById = (id, groupId) => {
	const url = `api/partners/${id}?expand=partner_contact_title,partner_contact_phone,partner_contact_email,partner_contact_name,partner_site_url,partner_description,partner_location,partner_map,partner_contact_state,partner_contact_city,partnerGiveaways,uploads,follow_status,follow_note,mapUrl&group_id=${groupId}`
	return axios.get(url)
}
/**
 * @param {Number} id
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */

export const putExhibitorPartnersFollow = (id, data) => {
	const url = `api/partners-follow/${id}`
	return axios.put(url, data)
}
/**
 * @param {Number} id
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */

export const deleteExhibitorPartnersFollow = (id, data) => {
	const url = `api/partners-follow/${id}`
	return axios.delete(url, { data })
}
/**
 * @param {String} query
 *
 * @returns {Promise<Object>}
 */
export const getBoothStaffList = (query) => {
	const url = `api/users?filter=exhibitors&${query}`
	return axios.get(url)
}
